import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage  from './pages/LandingPage';
import FinmapPage   from './pages/FinmapPage';
import ProjectDetail from './pages/ProjectDetail';
import BlogsPage    from './pages/BlogsPage';
import BlogPost     from './pages/BlogPost';
import MiraSignalPage from './pages/MiraSignalPage';

const App = () => {
  const [darkTheme, setDarkTheme] = useState(() => {
    const savedTheme = localStorage.getItem('selected-theme');
    return savedTheme === 'dark';
  });

  useEffect(() => {
    if (darkTheme) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
    localStorage.setItem('selected-theme', darkTheme ? 'dark' : 'light');
  }, [darkTheme]);

  const toggleTheme = () => {
    setDarkTheme(!darkTheme);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/"              element={<LandingPage  darkTheme={darkTheme} toggleTheme={toggleTheme} />} />
          <Route path="/finmap"        element={<FinmapPage />} />
          <Route path="/projects/:id"  element={<ProjectDetail />} />
          <Route path="/blog"          element={<BlogsPage    darkTheme={darkTheme} toggleTheme={toggleTheme} />} />
          <Route path="/blog/:slug"    element={<BlogPost     darkTheme={darkTheme} toggleTheme={toggleTheme} />} />
          <Route path="/mirasignal"    element={<MiraSignalPage darkTheme={darkTheme} toggleTheme={toggleTheme} />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
